// extracted by mini-css-extract-plugin
export default {"printSignature":"TerminateText_printSignature__BngL6"};